module.exports = __webpack_public_path__ + "img/download.5005a86c.webp";